import React from 'react'
import { useNavigate } from 'react-router'
import styled from '@emotion/styled'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { Button } from '@mobi/component-library/Base/Buttons'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { FeatureIcon } from '@mobi/component-library/Assets/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { routes } from '../../SignUp/Utils'
import { AccountNumberDisplay } from './VerificationAccountPages.styled'
import { VerificationAccountPage } from './VerificationAccountInformationPage'
import { useBetAccount } from '@mobi/account/Hooks'

export const VerificationAccountCompletePage = () => {
  const navigate = useNavigate()
  const { data } = useBetAccount()
  return (
    <VerificationAccountPage>
      <AccountHeader
        alignItems='start'
        title={
          <Flex flexDirection='column' gap={spacing.md}>
            <FeatureIcon type='success' size='xl' />
            <span>Your identity has been successfully verified </span>
          </Flex>
        }
        description={
          <span>
            Thank you for submitting your identity information. We've created a verification record
            so you can confirm your identity when requested in a TAB venue.
          </span>
        }
        style={{ marginBottom: '0rem' }}
      />
      <AccountNumberDisplay>
        <b>{data?.BetAccountNumber}</b>
        <div style={{ display: 'flex', columnGap: spacing.smx2 }}>
          <span>Account Number</span>
        </div>
      </AccountNumberDisplay>
      <div>
        Please keep this number handy. You may be asked to quote this number by TAB venue staff in
        scenarios such as:
        <ul style={{ paddingLeft: spacing.big, marginBottom: 0 }}>
          <li>Large payouts</li>
          <li>Participation in Punters' Clubs</li>
        </ul>
      </div>
      <Button isFullWidth color='primary' onClick={() => navigate(routes.home)}>
        Done
      </Button>
      <Footer>
        If you have questions about your verification-only account, or need support, please contact
        us on <CustomerServiceTelephone />
      </Footer>
    </VerificationAccountPage>
  )
}

const Footer = styled.div({
  ...font.size.md,
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  color: colors.neutral[600],
  textAlign: 'center',

  a: {
    color: 'inherit',
  },
})
